module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3jtoA"))).then(() => parcelRequire('bO9ze'));